/* Theme-independent bridge: verified cart metadata, no contact or payment data. */
(function () {
  'use strict';
  var cookieName = 'lf_checkout_products_v1';
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function text(value) {
    return typeof value === 'string' && value.length > 0 && value.length <= 80 &&
      value.trim() === value && !/[\u0000-\u001f\u007f]/.test(value) ? value : undefined;
  }
  function write(target) {
    if (!allowed()) {
      document.cookie = cookieName + '=; Path=/; Max-Age=0; SameSite=Lax; Secure';
      return;
    }
    var container = target && (target.closest('cart-drawer') || target.closest('.cc-main-cart'));
    var cartNode = (container || document).querySelector('[data-lf-cart]');
    if (!cartNode) return;
    var cart;
    try { cart = JSON.parse(cartNode.textContent); } catch (_) { return; }
    if (!cart || !Array.isArray(cart.items) || !cart.items.length || cart.items.length > 20) return;
    var items = cart.items.map(function (line) {
      var product = line.product || {};
      return { sku: String(product.sku || ''), spu: String(product.spu || ''),
        product_size: text(product.product_size), product_color: text(product.product_color) };
    });
    if (items.some(function (item) { return !/^[1-9]\d*$/.test(item.sku) || !/^[1-9]\d*$/.test(item.spu); })) return;
    var value = encodeURIComponent(JSON.stringify({ v: 1, at: Date.now(), items: items }));
    if (value.length > 3500) return;
    document.cookie = cookieName + '=' + value + '; Path=/; Max-Age=1800; SameSite=Lax; Secure';
  }
  // Only reads Liquid metadata already present in the page. Shopping actions are never intercepted.
  document.addEventListener('click', function (event) {
    try {
      var target = event.target.closest && event.target.closest('[name="checkout"],[data-lf-checkout]');
      if (target) write(target);
    } catch (_) { /* Tracking must not affect checkout. */ }
  }, true);
  document.addEventListener('submit', function (event) {
    try { if (event.submitter && event.submitter.name === 'checkout') write(event.target); }
    catch (_) { /* Tracking must not affect checkout. */ }
  }, true);
  document.addEventListener('visitorConsentCollected', function () { try { write(); } catch (_) {} });
  try { write(); } catch (_) { /* Optional metadata remains absent on failure. */ }
}());
